import { Component, OnInit } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { filter } from 'rxjs/operators';
import { Global } from 'src/app/shared/global';
import { FormService } from 'src/app/shared/services/form.service';
import { Location } from '@angular/common';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit {
  displayResetButton: boolean = false;
  displayOpenCalcButton: boolean = false;

  constructor(private router: Router, private global: Global, private formService: FormService, private location: Location) {
    router.events.pipe(filter(event => event instanceof NavigationEnd)).subscribe(event => {
      document.querySelector('#top').scrollIntoView();

      if (router.url.includes('/whats-next')) {
        this.displayResetButton = true;
      } else {
        this.displayResetButton = false;
      }

      this.displayOpenCalcButton = (global.getEduLessonObj);
    })
  }

  ngOnInit(): void {
  }

  redirectHome() {
    //this.router.navigateByUrl('/');
    // this.router.navigate(['/'], { queryParams: { org: this.global.orgID } });
    window.location.reload();
  }

  reset() {
    this.formService.resetFormData();
    this.redirectHome();
  }

  openCalculator(){
    this.global.getEduLessonObj = null;
    this.router.navigate(['/plan-for-year'], { queryParams: { org: this.global.orgID } });
  }

}
